import React from 'react'

const Paused = ({ width = '170', height = '164', fill = 'none' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 170 164"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M76.8596 33.0971L33.9014 95.8498"
        stroke="#1D2943"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.8765 34.5742L128.162 80.4268"
        stroke="#1D2943"
        strokeWidth="2"
      />
      <rect
        width="133.473"
        height="39.2706"
        transform="matrix(0.990665 -0.13632 0.134925 0.990856 14.3564 95.2644)"
        fill="url(#paint0_linear_1524_19082)"
      />
      <path
        d="M146.991 80.0304L151.88 116.003L24.8308 133.443"
        stroke="#1D2943"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.8123 115.026L52.3322 115.229L50.7152 103.332L55.4944 102.676C57.884 102.348 59.4445 103.806 59.7087 105.75C59.973 107.694 58.8229 109.523 56.469 109.846L53.1699 110.299L53.8123 115.026ZM56.1112 108.551C57.52 108.358 58.3569 107.298 58.1751 105.96C57.9933 104.623 56.9043 103.827 55.4955 104.021L52.3748 104.449L52.9905 108.979L56.1112 108.551ZM71.6052 112.583L69.9111 112.816L68.5002 110.321L62.5797 111.133L61.8864 113.918L60.1923 114.15L63.3545 101.597L65.1913 101.345L71.6052 112.583ZM67.875 109.062L64.4903 103.004L62.8283 109.755L67.875 109.062ZM77.5697 111.983C74.342 112.426 72.4598 110.74 72.0623 107.815L71.0732 100.538L72.5533 100.335L73.5375 107.576C73.8333 109.752 75.1969 110.964 77.3903 110.663C79.5838 110.362 80.5741 108.827 80.2783 106.651L79.2941 99.4094L80.7742 99.2063L81.7609 106.466C82.1633 109.426 80.7975 111.54 77.5697 111.983ZM89.0575 110.406C86.9889 110.69 85.3665 110.113 84.2354 109.142L84.9564 107.898C85.8599 108.665 87.2553 109.309 88.9316 109.079C91.0537 108.787 91.5762 107.553 91.4526 106.643C91.0356 103.575 84.222 106.237 83.645 101.992C83.3783 100.03 84.9441 98.4522 87.2802 98.1315C89.0992 97.8818 90.5904 98.2949 91.7321 99.2101L90.9883 100.42C89.9633 99.5619 88.6544 99.2874 87.3526 99.4661C85.926 99.6619 85.0138 100.568 85.1665 101.692C85.5301 104.367 92.3656 101.867 92.9692 106.308C93.2044 108.038 92.2674 109.965 89.0575 110.406ZM103.418 108.217L95.6254 109.286L94.0085 97.3896L101.801 96.3199L101.981 97.6398L95.668 98.5063L96.1892 102.341L102.377 101.492L102.557 102.812L96.3686 103.661L96.9262 107.763L103.239 106.897L103.418 108.217ZM109.844 107.334L105.778 107.893L104.161 95.996L108.227 95.4378C111.919 94.9311 114.678 97.1869 115.136 100.558C115.596 103.947 113.536 106.828 109.844 107.334ZM109.665 106.015C112.554 105.618 113.949 103.319 113.602 100.768C113.253 98.2 111.349 96.3538 108.407 96.7577L105.821 97.1126L107.079 106.37L109.665 106.015Z"
        fill="#1D2943"
      />
      <path
        d="M81.5034 46.173C85.7484 44.9478 88.2103 40.5093 87.0023 36.2594C85.7942 32.0095 81.3736 29.5575 77.1286 30.7827C72.8836 32.008 70.4217 36.4465 71.6298 40.6964C72.8378 44.9463 77.2584 47.3983 81.5034 46.173Z"
        fill="#1D2943"
      />
      <path
        d="M81.5034 43.6757C85.7484 42.4505 88.2103 38.012 87.0023 33.7621C85.7942 29.5122 81.3736 27.0602 77.1286 28.2854C72.8836 29.5107 70.4217 33.9491 71.6298 38.1991C72.8378 42.449 77.2584 44.901 81.5034 43.6757Z"
        fill="#004360"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1524_19082"
          x1="14.7657"
          y1="40.3942"
          x2="147.55"
          y2="-5.07151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E2E2FC" />
          <stop offset="1" stopColor="#F8F8FD" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Paused
